import React from 'react';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import api from '../../../services/api';
import {
  Button,
  Typography,
  Divider,
  Stack,
  Popover,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useStoreActions } from "easy-peasy";
import { NoRowsOverlay } from "../../../components";
import DeleteIcon from "@mui/icons-material/Delete";
import { pt } from "yup-locale-pt";
import * as yup from "yup";
import DialogoEventos from "./DialogoEventos";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {participacaoOptions} from "./static";

yup.setLocale(pt);

const Eventos = ({ ano, empresa }) => {
  let startLoading = useStoreActions(actions => actions.nav.startLoading);
  let stopLoading = useStoreActions(actions => actions.nav.stopLoading);

  const [rows, setRows] = React.useState([]);
  const [openDlgEvento, setOpenDlgEvento] = React.useState(false);
  const [selectedEvento, setSelectedEvento] = React.useState();

  const participacaoObj = participacaoOptions.reduce((map, item) => {
    map[item.id] = item.label;
    return map;
  }, {});

  const loadEventos = async mount => {
    startLoading();
    try {
      let getRows = (
        await api.http.get(`/09/eventos/empresa/${empresa}/${ano}`)
      ).data;
      if (!mount || mount.isMounted) setRows(getRows);
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };

  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    loadEventos(mount);
    return () => {
      mount.isMounted = false;
    };
  }, [ano, empresa]);

  const deleteDados = React.useCallback(
    id => async () => {
      startLoading();
      try {
        await api.http.delete(`/09/eventos/empresa/${empresa}/${id}`);
        loadEventos();
        stopLoading({ severity: 'success' });
      } catch (error) {
        stopLoading({
          message: error.toString(),
          severity: 'error'
        });
      }
    },
    []
  );

  const columns = React.useMemo(
    () => [
      {
        field: 'nomeEvento',
        headerName: 'Nome do Evento',
        flex: 1
      },
      {
        field: 'participacao',
        headerName: 'Patrocinou, Fomentou ou Paticipou',
        flex: 1,
        valueGetter: (value, row) => participacaoObj[row.participacao]
      },
      {
        field: 'actions',
        type: 'actions',
        headerName: 'Remover',
        width: 100,
        getActions: params => [
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={deleteDados(params.id)}
          />
        ]
      }
    ],
    [deleteDados]
  );

  const novoRegistro = async () => {
    setOpenDlgEvento(true);
  };

  const onCloseDlgEventos = reload => {
    setOpenDlgEvento(false);
    setSelectedEvento(null);
    if (reload) {
      loadEventos();
    }
  };

  const onRowClick = (params, event, details) => {
    setSelectedEvento(params.row);
    setOpenDlgEvento(true);
  };

  // POPOVER
  const [anchorEl, setAnchorEl] = React.useState(null);

  // HANDLE CLICKS
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  // HANDLE CLOSES
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    (<div>
      <Divider sx={{ mt: 3 }}>
        <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
          <h3>Eventos</h3>
          <HelpOutlineIcon
            onClick={handleClick}
            sx={{
              m: 2
            }}
          />
          <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
          >
            <Typography sx={{ p: 2 }}>
              O objetivo desta seção é identificar a participação da sua empresa
              em
              <br />
              eventos do ecossistema de inovação (ex: Campus Party, CASE, etc.).
            </Typography>
          </Popover>
        </Stack>
      </Divider>
      <Typography sx={{ mb: 2 }}>
        Quais são os principais eventos de inovação que sua empresa
        patrocinou/fomentou/participou institucionalmente no ano de
        referência?(Participação voluntária de funcionários e ações não
        institucionalizadasnão devem ser consideradas)
      </Typography>
      <DialogoEventos
        empresa={empresa}
        ano={ano}
        selectedEvento={selectedEvento}
        open={openDlgEvento}
        onClose={onCloseDlgEventos}
      />
      <Grid style={{ textAlign: "right" }} size="grow">
        <Button
          color="primary"
          variant="outlined"
          onClick={novoRegistro}
        >
          Novo Evento
        </Button>
      </Grid>
      <DataGrid
        sx={{ height: 400, mt: 2 }}
        rows={rows}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
        onRowClick={onRowClick}
        slots={{ noRowsOverlay: NoRowsOverlay }}
        disableSelectionOnClick
      />
    </div>)
  );
};

export default Eventos;
